import { compareStrings } from '../../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/sorters';
import { ColumnKeys } from '../grid-config';
import { getExchangeAntimalwareScanTaskTargetType } from '../../../../../../utils/uiSettings/exchange/exchange-protection.values';
import { ExchangeAntimalwareScanTaskFrontendFields } from '../GzExchangeAntimalwareScanTasksGridDataProvider';

// sort by column type
export function sortByColumn(
  item1: ExchangeAntimalwareScanTaskFrontendFields,
  item2: ExchangeAntimalwareScanTaskFrontendFields,
  columnName: string,
  direction: string
): number {
  switch (columnName) {
    case ColumnKeys.NAME:
      return compareStrings(item1.name, item2.name, direction);
    case ColumnKeys.TARGET_TYPE:
      return compareStrings(
        getExchangeAntimalwareScanTaskTargetType(item1.targetType),
        getExchangeAntimalwareScanTaskTargetType(item2.targetType),
        direction
      );
  }

  return 0;
}
